import type { PartnerAssignment, PartnerRole } from "../../Lib/partnerApi";

export type PartnerTab = "overview" | "workshops" | "internships" | "interviews" | "profile";

export function courseAssignments(assignments: PartnerAssignment[], courseType?: "WORKSHOP" | "INTERNSHIP") {
    return assignments.filter((assignment) => assignment.resourceType === "COURSE_RUN" && (!courseType || assignment.courseType === courseType));
}

export function availablePartnerTabs(roles: readonly PartnerRole[], assignments: PartnerAssignment[], mockInterviewsEnabled: boolean): PartnerTab[] {
    const hasWorkshopWork = courseAssignments(assignments, "WORKSHOP").length > 0;
    const hasInternshipWork = courseAssignments(assignments, "INTERNSHIP").length > 0;
    const hasInterviewWork = assignments.some((assignment) => assignment.resourceType === "INTERVIEW_BOOKING");
    const tabs: PartnerTab[] = ["overview"];
    if (roles.includes("WORKSHOP_MENTOR") || hasWorkshopWork) tabs.push("workshops");
    if (roles.includes("INTERNSHIP_MENTOR") || hasInternshipWork) tabs.push("internships");
    if (mockInterviewsEnabled && (roles.some((role) => role.endsWith("_INTERVIEWER")) || hasInterviewWork)) tabs.push("interviews");
    tabs.push("profile");
    return tabs;
}

export function safePartnerTab(requested: string | null, available: readonly PartnerTab[]): PartnerTab {
    return available.includes(requested as PartnerTab) ? requested as PartnerTab : "overview";
}

export function isUpcoming(assignment: PartnerAssignment, now = Date.now()) {
    return !assignment.scheduledAt || new Date(assignment.scheduledAt).getTime() >= now;
}

export function courseState(assignment: PartnerAssignment, now = Date.now()): "current" | "upcoming" | "finished" {
    if (assignment.courseStatus === "completed" || assignment.courseStatus === "cancelled" || Boolean(assignment.endsAt && new Date(assignment.endsAt).getTime() < now)) return "finished";
    if (assignment.scheduledAt && new Date(assignment.scheduledAt).getTime() > now) return "upcoming";
    return "current";
}
